import { DropdownMenu as DropdownMenuBase } from '@findy-code/yuffie/shared/dropdown-menu';
import type { ComponentProps } from 'react';
import { forwardRef } from 'react';

import styles from './dropdown-menu.component.module.scss';

export const DropdownMenu = forwardRef<HTMLUListElement, ComponentProps<'ul'>>(
  (props, ref) => {
    const { className, children, ...rest } = props;
    return (
      <DropdownMenuBase
        className={[className, styles.dropdownMenu].filter(Boolean).join(' ')}
        ref={ref}
        {...rest}
      >
        {children}
      </DropdownMenuBase>
    );
  }
);

DropdownMenu.displayName = 'DropdownMenu';
